(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sic-customer-reviews"]) return;
  try {
    
if (!customElements.get('sic-review-request')) {
  customElements.define('sic-review-request', class extends HTMLElement {
    connectedCallback() {
      if (this.reviewReady) return;
      this.reviewReady = true;
      this.reviewController = new AbortController();
      const options = {signal: this.reviewController.signal};
      const dialog = this.querySelector('dialog');
      const invitation = this.querySelector('[data-review-invite]');
      const openButton = this.querySelector('[data-review-open]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const open = () => {
        invitation.hidden = false;
        this.reviewOpener = document.activeElement;
        if (!dialog.open) dialog.showModal();
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sic-review-is-open');
        const result = dialog.querySelector('[data-review-result]');
        if (result) result.focus();
      };
      openButton.addEventListener('click', open, options);
      this.querySelector('[data-review-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sic-review-is-open');
        if (this.reviewOpener && this.reviewOpener !== document.body && this.reviewOpener.isConnected) this.reviewOpener.focus();
        else openButton.focus();
      }, options);
      const inviteFromLink = () => {
        const query = new URLSearchParams(window.location.search);
        if (window.location.hash === '#leave-review' || query.get('review') === '1') open();
      };
      window.addEventListener('hashchange', inviteFromLink, options);
      if (window.Shopify && window.Shopify.designMode) invitation.hidden = false;
      if (dialog.querySelector('[data-review-result]')) open();
      else inviteFromLink();
    }
    disconnectedCallback() {
      if (this.reviewController) this.reviewController.abort();
      document.documentElement.classList.remove('sic-review-is-open');
      this.reviewReady = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sic-reviews-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
  const shuffle = values => {
    const result = [...values];
    for (let index = result.length - 1; index > 0; index--) {
      const other = Math.floor(Math.random() * (index + 1));
      [result[index], result[other]] = [result[other], result[index]];
    }
    return result;
  };
  const chooseBatch = (pool, previous = {}, count = 5) => {
    const last = new Set(Array.isArray(previous.last) ? previous.last : []);
    const seen = new Set(Array.isArray(previous.seen) ? previous.seen : []);
    const fresh = shuffle(pool.filter(review => !last.has(review.id) && !seen.has(review.id)));
    const priority = fresh.findIndex(review => review.priority);
    if (priority > 0) fresh.unshift(...fresh.splice(priority, 1));
    const used = shuffle(pool.filter(review => !last.has(review.id) && seen.has(review.id)));
    const repeat = shuffle(pool.filter(review => last.has(review.id)));
    const selected = [...fresh, ...used, ...repeat].slice(0, count);
    if (selected.length > 1 && selected[0].id === previous.first) [selected[0], selected[1]] = [selected[1], selected[0]];
    const validIds = new Set(pool.map(review => review.id));
    const combined = [...new Set([...seen, ...selected.map(review => review.id)])].filter(id => validIds.has(id));
    return { selected, state: { last:selected.map(review => review.id), first:selected[0]?.id || '', seen:combined.length >= pool.length ? selected.map(review => review.id) : combined } };
  };
  class SicHomeReviews extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const read = selector => JSON.parse(this.querySelector(selector)?.textContent || 'null');
      let config, archive, manual;
      try { config=read('[data-review-config]'); archive=read('[data-review-archive]'); manual=read('[data-review-manual]'); } catch { return; }
      if (!config || config.designMode) return;
      this.config = config;
      const hidden = String(config.hidden || '').split(/\r?\n/).map(value => value.trim().toLocaleLowerCase()).filter(Boolean);
      const withheld = new Set((manual || []).filter(review => review.published === false).map(review => normalize(review.b)));
      const matchesHidden = review => hidden.some(value => String(review.id) === value || String(review.a || '').toLocaleLowerCase() === value || String(review.b || '').toLocaleLowerCase().includes(value));
      const candidates = (manual || []).filter(review => review.published !== false).concat(config.archive ? (archive || []) : []);
      const unique = new Set();
      this.pool = candidates.filter(review => {
        const key = normalize(review.b);
        if (!key || withheld.has(key) || unique.has(key) || matchesHidden(review)) return false;
        unique.add(key);
        return true;
      }).map(review => ({...review,id:String(review.id)}));
      if (!this.pool.length) { this.hidden = true; return; }
      this.track = this.querySelector('.reviews-grid');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.more = this.querySelector('[data-review-more]');
      this.storageKey = 'sic_home_reviews_rotation_v1';
      this.state = {};
      try { this.state = JSON.parse(localStorage.getItem(this.storageKey) || '{}') || {}; } catch {}
      this.prev.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.more.addEventListener('click', () => this.showBatch());
      this.track.addEventListener('scroll', () => this.updateArrows(), {passive:true});
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.track);
      this.querySelector('.sic-review-controls').hidden = false;
      this.more.hidden = this.pool.length <= 5;
      this.showBatch();
    }
    showBatch() {
      const batch = chooseBatch(this.pool, this.state);
      this.state = batch.state;
      try { localStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch {}
      const cards = batch.selected.map(review => {
        const card=document.createElement('div'); card.className='review-card'; card.setAttribute('role','listitem'); card.dataset.reviewId=review.id;
        const quote=document.createElement('p'); quote.textContent=review.b; card.append(quote);
        const meta=document.createElement('div'); meta.className='meta';
        const name=document.createElement('strong'); name.textContent=review.a || this.config.customer; meta.append(name); card.append(meta);
        if (review.product) { const product=document.createElement('div'); product.className='product'; product.textContent=review.product; card.append(product); }
        const label=document.createElement('div'); label.className='verified'; label.textContent=review.verified ? this.config.verified : this.config.customer; card.append(label);
        return card;
      });
      this.track.replaceChildren(...cards);
      document.dispatchEvent(new CustomEvent("sic:content-updated"));
      this.track.scrollLeft = 0;
      requestAnimationFrame(() => this.updateArrows());
    }
    move(direction) {
      const card=this.track.firstElementChild;
      if (!card) return;
      const gap=parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    updateArrows() {
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready=false; }
  }
  if (!customElements.get('sic-home-reviews')) customElements.define('sic-home-reviews', SicHomeReviews);
})();

  } catch(e) { console.error(e); }
})();
})();
